import { getWechat } from "../api/wechat";
import { savePoint } from "../utils/savePoint";
import getSystemInfo from "../utils/getSystemInfo";

const setID = (function() {
  function t() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
      var e = (16 * Math.random()) | 0;
      return ("x" == t ? e : (3 & e) | 8).toString(16);
    });
  }
  var e = "nfplus_deviceid";
  if (
    (function() {
      var t = "localstorage_support_test",
        e = window.sessionStorage;
      try {
        return e.setItem(t, "testValue"), e.removeItem(t), !0;
      } catch (t) {
        return !1;
      }
    })()
  ) {
    var n = window.localStorage.getItem(e) || "";
    return "" == n && ((n = t()), window.localStorage.setItem(e, n)), n;
  }
  return t();
})();
const to = (function() {
  let deviceid = window.localStorage.getItem("nfplus_deviceid");
  getSystemInfo()
    .then(res => {
      console.log(res, "res");
      // 进入疫情地图页面 => 地图埋点
      const system = {
        default: 4, // 其他方式打开
        isWx: 2, // 微信
        pc: 3, // 浏览器打开
        isNfPlus: 1 // 端内打开
      };
      // 获取哪一部分
      let whichSystem = "default";
      const { ios, pc, android, isWx, isPhoneX, isNfPlus } = res;
      if (isWx) {
        whichSystem = "isWx";
      } else if (isNfPlus) {
        whichSystem = "isNfPlus";
      } else if (pc) {
        whichSystem = "pc";
      } else {
        whichSystem = "default";
      }
      savePoint({
        deviceid,
        dataType: 1002019,
        url: window.location.href,
        refer: document.referrer,
        openType: system[whichSystem],
        action: "5"
      });
    })
    .catch(e => {
      console.log(e);
    });
})();

const wx = window.wx;

export async function initShare(
  shareConfig = {
    shareTitle: "海外疫情大事记",
    shareUrl: window.location.origin + window.location.pathname + "#/",
    shareIcon: process.env.NODE_ENV == "production" ? "https://static.nfapp.southcn.com/hd/yqh5/cover.jpg?v=1586055084549": "https://teststatic.nfapp.southcn.com/hd/yqh5/cover.jpg" ,
    shareDesc: "持续更新海外疫情进展"
  }
) {
  try {
    if (window.nfplusJsbridge) {
      window.nfplusJsbridge.setShareInfo({
        shareDesc: shareConfig.shareDesc,
        shareIcon: shareConfig.shareIcon,
        shareTitle: shareConfig.shareTitle,
        shareUrl: shareConfig.shareUrl
      });
    }
  } catch (e) {
    console.error(e)
  }
  
  const wxShareApiList = [
    "onMenuShareTimeline",
    "onMenuShareAppMessage",
    "onMenuShareQQ",
    "onMenuShareWeibo",
    "onMenuShareQZone"
  ];
  let shareInfo = await getWechat();

  const wxShareConfig = index => ({
    title: shareConfig.shareTitle,
    desc: shareConfig.shareDesc,
    link: shareConfig.shareUrl,
    imgUrl: shareConfig.shareIcon,
    success: async () => {
      // 分享地图埋点: 疫情页面分享
      savePoint({
        deviceid: window.localStorage.getItem("nfplus_deviceid") || "",
        dataType: 1002021,
        origin: 2,
        action: "5"
      });
    }
  });

  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: shareInfo.app_id, // 必填，公众号的唯一标识
    timestamp: shareInfo.timestamp, // 必填，生成签名的时间戳
    nonceStr: shareInfo.nonceStr, // 必填，生成签名的随机串
    signature: shareInfo.signature, // 必填，签名，见附录1
    jsApiList: [
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareWeibo",
      "onMenuShareQZone",
      "chooseWXPay"
    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
  wx.ready(() => {
    for (const [index, item] of wxShareApiList.entries()) {
      wx[item](wxShareConfig(index));
    }
  });
}
